module.exports = __webpack_public_path__ + "static/media/flag_es_ES.d71082b9.png";